import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { DropDownListWithImage } from "../../../Common/Components/DropDownListWithImage";

const ChangeOwnerModal = ({ show,isSubmitting, onClose, onSave, owners }) => {
  const [selectedOwner, setSelectedOwner] = useState(0);

  const handleSave = () => {
    onSave(selectedOwner);
   
   
  };

  return (
    <Modal show={show} onHide={onClose} centered className="change-owner-modal"
    backdropClassName="change-owner-overlay"
    >
      <Modal.Header closeButton>
        <Modal.Title>Change Owner</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="selectOwner">
            <Form.Label>Select Owner</Form.Label>
            <DropDownListWithImage
              defaultValue={selectedOwner}
              placeHolder={"Search for a user"}
              dropdownPlaceHolder="Select Owner"
              data={[
                // ...[
                //   {
                //     user_UniqueId: 0,
                //     employee: "select a user",
                //     imagePath: "",
                //   },
                // ],
                ...owners,
              ]}
              isSearchRequired={true}
              label={"employee"}
              subLabel={"roleName"}
              value={"user_UniqueId"}
              imageUrl={"imagePath"}
              onDropDownChange={(item) => {
                setSelectedOwner(item?.user_UniqueId || 0);
              }}
              selectedItem={[
                ...[
                  {
                    user_UniqueId: 0,
                    employee: "Select Owner",
                    imagePath: "",
                  },
                ],
                ...owners?.filter((item) => item?.user_UniqueId),
              ].find((r) => r.user_UniqueId === selectedOwner)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={isSubmitting || selectedOwner == 0} variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeOwnerModal;
